import AsideAccessRights from '@UI/aside/asideAccessRights/AsideAccessRights';
import AsideAgeRange from '@UI/aside/asideAgeRange/AsideAgeRange';
import AsideAttachedContent from '@UI/aside/asideAttachedContent/AsideAttachedContent';
import AsideAttachmentGroupType from '@UI/aside/asideAttachmentGroupType/AsideAttachmentGroupType';
import AsideCheckbox from '@UI/aside/asideCheckbox/AsideCheckbox';
import AsideColor from '@UI/aside/asideColor/AsideColor';
import AsideConcordanties from '@UI/aside/asideConcordanties/AsideConcordanties';
import AsideCoverage from '@UI/aside/asideCoverage/AsideCoverage';
import AsideCurriculumSelector from '@UI/aside/asideCurriculumSelector/AsideCurriculumSelector';
import AsideCurriculumTheme from '@UI/aside/asideCurriculumTheme/asideCurriculumTheme';
import AsideCurriculumType from '@UI/aside/asideCurriculumType/AsideCurriculumType';
import AsideDatePicker from '@UI/aside/asideDatePicker/AsideDatePicker';
import AsideDateToSendPicker from '@UI/aside/asideDatePicker/AsideDateToSendPicker';
import AsideIssuedDatePicker from '@UI/aside/asideDatePicker/AsideIssuedDatePicker';
import AsideDescription from '@UI/aside/asideDescription/AsideDescription';
import AsideDevelopmentPhase from '@UI/aside/asideDevelopmentPhase/AsideDevelopmentPhase';
import AsideFile from '@UI/aside/asideFileSelector/AsideFile';
import AsideFoundationalSuggestions from '@UI/aside/asideFoundationalSuggestions/AsideFoundationalSuggestions';
import AsideFreeTextAuthor from '@UI/aside/asideFreeTextAuthor/AsideFreeTextAuthor';
import AsideGoalRelations from '@UI/aside/asideGoalRelations/AsideGoalRelations';
import AsideGoalsByZillIllustration from '@UI/aside/asideGoalsByZillIllustration/asideGoalsByZillIllustration';
import AsideImage from '@UI/aside/asideImage/AsideImage';
import AsideLeerlijnReference from '@UI/aside/asideLeerlijnReference/AsideLeerlijnReference';
import AsideLinks from '@UI/aside/asideLinks/AsideLinks';
import AsideMenuItemReference from '@UI/aside/asideMenuItemReference/AsideMenuItemReference';
import AsideNamedSet from '@UI/aside/asideNamedSet/AsideNamedSet';
import AsideNewsletterSender from '@UI/aside/asideNewsletterSender/AsideNewsletterSender';
import AsideNodeVersions from '@UI/aside/asideNodeVersions/AsideNodeVersions';
import AsidePersonPicker from '@UI/aside/asidePersonPicker/AsidePersonPicker';
import AsidePracticalExampleReferences from '@UI/aside/asidePracticalExampleReferences/asidePracticalExampleReferences';
import AsidePreviousVersion from '@UI/aside/asidePreviousVersion/AsidePreviousVersion';
import AsidePreviousVersionItems from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItems';
import AsideReferenceFrameReferences from '@UI/aside/asideReferenceFrameReferences/AsideReferenceFrameReferences';
import AsideReferenceGroup from '@UI/aside/asideReferenceGroup/AsideReferenceGroup';
import AsideTitle from '@UI/aside/asideRichTextInput/AsideTitle';
import AsideSecondaryEducationType from '@UI/aside/asideSecondaryEducationType/AsideSecondaryEducationType';
import AsideSimpleDropDown from '@UI/aside/asideSimpleDropDown/AsideSimpleDropDown';
import AsideIdentifier from '@UI/aside/asideSimpleInput/AsideIdentifier';
import AsideValidityPeriod from '@UI/aside/asideSimpleInput/AsideValidityPeriod';
import AsideVersion from '@UI/aside/asideSimpleInput/AsideVersion';
import AsideSources from '@UI/aside/asideSources/AsideSources';
import AsideStaticHtml from '@UI/aside/asideStaticHtml/AsideStaticHtml';
import AsideStudyProgrammes from '@UI/aside/asideStudyProgrammes/AsideStudyProgrammes';
import AsideSubjects from '@UI/aside/asideSubjects/AsideSubjects';
import AsideTeaserImportance from '@UI/aside/asideTeaserImportance/AsideTeaserImportance';
import AsideTeaserLinkedContent from '@UI/aside/asideTeaserLinkedContent/AsideTeaserLinkedContent';
import AsideThemes from '@UI/aside/asideThemes/AsideThemes';
import AsideVideo from '@UI/aside/asideVideo/AsideVideo';
import AsideWebDatePicker from '@UI/aside/asideWebDatePicker/AsideWebDatePicker';
import AsideReferenceFramePicker from '@UI/aside/asideWebFacet/AsideReferenceFramePicker';
import AsideWebFacetPlaceHolder from '@UI/aside/asideWebFacet/AsideWebFacetPlaceHolder';
import AsideZillGoals from '@UI/aside/asideWebFacet/AsideZillGoals';
import AsideWebFacets from '@UI/aside/asideWebFacets/AsideWebFacets';
import AsideWebOldUrls from '@UI/aside/asideWebOldUrls/AsideWebOldUrls';
import AsideWebSimpleCheckbox from '@UI/aside/asideWebSimpleCheckbox/AsideWebSimpleCheckbox';
import AsideWebSimpleInput from '@UI/aside/asideWebSimpleInput/AsideWebSimpleInput';
import AsideWebType from '@UI/aside/asideWebType/AsideWebType';
import AsideZillIllustrations from '@UI/aside/asideZillIllustrations/asideZillIllustrations';

import type {
  AudienceTabComponent,
  EditComponent,
  FilteredEditComponent,
  WebTabComponent,
} from '@nodeTypeConfig/configTypes';
import { selectAsideConfig, selectCurrentEditingNode } from '@store/selectors/asideSelectors';
import type React from 'react';
import { useReadOnly } from '../../hooks/UseReadonly';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import AsideValidation from './asideValidationErrors/AsideValidation';
import AsideChangeIndicator from './changeIndicators/asideChangeIndicator/AsideChangeIndicator';

const asideComponents = [
  AsideWebFacets,
  AsideWebOldUrls,
  AsideWebSimpleInput,
  AsideWebSimpleCheckbox,
  AsideWebType,
  AsideWebDatePicker,
  AsideAttachmentGroupType,
  AsideFreeTextAuthor,
  AsideNewsletterSender,
  AsideSources,
  AsideSimpleDropDown,
  AsideValidityPeriod,
  AsideVersion,
  AsideImage,
  AsideVideo,
  AsideFile,
  AsideIdentifier,
  AsideTitle,
  AsideSubjects,
  AsideStaticHtml,
  AsideDescription,
  AsidePreviousVersion,
  AsidePreviousVersionItems,
  AsideSecondaryEducationType,
  AsideCheckbox,
  AsidePersonPicker,
  AsideColor,
  AsideTeaserImportance,
  AsideReferenceFrameReferences,
  AsideDatePicker,
  AsideDateToSendPicker,
  AsideIssuedDatePicker,
  AsideLinks,
  AsideCurriculumTheme,
  AsideStudyProgrammes,
  AsideNamedSet,
  AsideCoverage,
  AsideCurriculumSelector,
  AsideTeaserLinkedContent,
  AsideAttachedContent,
  AsideConcordanties,
  AsideDevelopmentPhase,
  AsideWebFacetPlaceHolder,
  AsideAgeRange,
  AsideReferenceFramePicker,
  AsideZillGoals,
  AsideThemes,
  AsideAccessRights,
  AsideCurriculumType,
  AsidePracticalExampleReferences,
  AsideZillIllustrations,
  AsideGoalsByZillIllustration,
  AsideMenuItemReference,
  AsideFoundationalSuggestions,
  AsideLeerlijnReference,
  AsideReferenceGroup,
  AsideGoalRelations,
];

const asideEditComponentMap = new Map<string, React.FC<{ config: any; readonly: boolean }>>(
  asideComponents.map((component) => [component.displayName as string, component]),
);

const getAsideEditComponentKey = (config: EditComponent, index: number) => {
  return `${config.component}-${config.property}-${index}`;
};

const getReadOnly = (config: EditComponent, nodeReadonly: boolean) => {
  return ('readonly' in config && config.readonly) || nodeReadonly || false;
};

const AsideBody: React.FC<Record<string, never>> = () => {
  const editConfig = useTypedSelector(
    (state) =>
      state.documentUI.currentEditingNode &&
      selectCurrentEditingNode(state) &&
      selectAsideConfig(state, state.documentUI.currentEditingNode, state.documentUI.asideTab),
  );

  const nodeReadonly = useReadOnly();

  return (
    <div className="row aside-body">
      <div id="content-column" className="col-xs-12">
        <div className="panel-body">
          <section className="group row">
            <AsideNodeVersions />
            {editConfig?.map(
              (
                config: FilteredEditComponent | AudienceTabComponent | WebTabComponent,
                index: number,
              ) => {
                const Component = asideEditComponentMap.get(config.reactComponent);
                return Component ? (
                  <div
                    className={`col-md-${config.width || 12} form-group ${
                      nodeReadonly ? 'aside-component-disabled' : ''
                    }`}
                    key={getAsideEditComponentKey(config, index)}
                  >
                    {!('noChangeMessage' in config && config.noChangeMessage) && (
                      <AsideChangeIndicator config={config} />
                    )}
                    <Component config={config} readonly={getReadOnly(config, nodeReadonly)} />
                    <AsideValidation property={config.property} component={config.component} />
                  </div>
                ) : null;
              },
            )}
            {!editConfig && (
              <div
                className="col-md-12"
                style={{
                  fontSize: '20px',
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '75vh',
                }}
              >
                Deze node is niet aanpasbaar of bestaat niet (meer).
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

AsideBody.displayName = 'AsideBody';
export default AsideBody;
